import CloseIcon from "@mui/icons-material/CloseTwoTone";
import { Box, Dialog } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { OrgSubscriptionPlan } from "../../../../models/billing.ts";
import styles from "./PricingPopup.module.scss";
import PricingContent from "../PricingContent/PricingContent.tsx";
interface IProps {
	open: boolean;
	onClose: () => void;
	onPlanClick: (plan: OrgSubscriptionPlan) => void;
}

const PricingPopup = ({ open, onClose, onPlanClick }: IProps) => {
	return (
		<Dialog
			classes={{
				paper: clsx(styles.container),
			}}
			onClose={() => {
				onClose();
			}}
			open={open}
			maxWidth={false}
		>
			<Box className={styles.closeIconContainer}>
				<CloseIcon onClick={onClose} className={styles.closeIcon} />
			</Box>
			<PricingContent onPlanClick={onPlanClick} onClose={onClose} className={styles.pricingContent}/>
		</Dialog>
	);
};

export default observer(PricingPopup);
